import { useCallback, useRef, useMemo } from 'react'
import { useIntl } from 'react-intl'
import GlobalMobileSearchHeroBar from 'components/SearchV2/Components/Mobile/GlobalMobileSearchHeroBar'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Sheet from 'components/utils/Sheet'
import MerchandiseSearchForm from '../MerchandiseSearch/MerchandiseSearchForm'
import useMerchandiseBrandsList from 'hooks/Merchandise/useMerchandiseBrandsList'
import useMerchandiseBrands from 'hooks/Merchandise/useMerchandiseBrands'

function MerchandiseLandingPageSearchBar() {
  const intl = useIntl()
  const [brandListIds] = useMerchandiseBrandsList({ sortBy: 'top' })
  const [brands] = useMerchandiseBrands(brandListIds)

  const containerRef = useRef<HTMLDivElement>(null)
  const onInputClick = useCallback(() => {
    containerRef.current?.scrollIntoView()
  }, [])

  const searchPlaceholderTextList = useMemo(() => {
    if (brands.length) {
      return brands.map(brand =>
        intl.formatMessage(
          {
            id: 'oiaWNKpbmvk8yX8psqxL',
            defaultMessage: 'products in {brandName}',
            description: 'Search placeholder text with brand name in the search and discovery interface',
          },
          { brandName: brand.name },
        ),
      )
    }
    return [
      intl.formatMessage({
        id: 'QmIkOc3HcE6dkdXSu9FN',
        defaultMessage: 'marketplace',
        description: 'Default search placeholder text for merchandise on the promotional landing page',
      }),
    ]
  }, [brands, intl])

  return <>
    <CSSBreakpoint max="tablet">
      <GlobalMobileSearchHeroBar
        placeholder={intl.formatMessage({
          id: '7m5wHarQ27SzgQU8eHvw',
          defaultMessage: 'Search',
          description: 'Search input placeholder text for merchandise on mobile',
        })}
        placeholderTextList={searchPlaceholderTextList}
      />
    </CSSBreakpoint>
    <CSSBreakpoint min="tablet">
      <Sheet ref={containerRef} padding={16} background="normal-background" shadow="flat-small">
        <MerchandiseSearchForm onInputClick={onInputClick} />
      </Sheet>
    </CSSBreakpoint>
  </>
}

export default MerchandiseLandingPageSearchBar
